<template>
  <DataTable ref="dataTable" :columns="columnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="4" :url="dataURL" :displayTools="false" :hasDateRangeFilter="false" :displayExportTools="false" exportTitle="Order Recovery">
    <template v-slot:title>
      <slot name="title" />
    </template>
    <template v-slot:tools>
      <slot name="tools" />
    </template>
    <template v-slot:row="row">
      <tr :key="row.data.id">
        <td class="table-data-nav-link">
          <a v-if="userHasCreatePermission(PermissionTypes.OrderPermissionTypes.order)" href="#" @click.prevent="recoverOrder(row.data.id)">
            {{row.data.id}}
          </a>
          <span v-else>
            {{row.data.id}}
          </span>
        </td>
        <td>
          {{row.data.name}}
        </td>
        <td>
          <LinkContact :id="row.data.contactId" :name="row.data.contact.name" />
        </td>
        <td>
          <LinkUser :id="row.data.userId" :name="row.data.user.name" />
        </td>
        <td>
          {{formatDateTime(row.data.createdAt)}}
        </td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import _ from 'lodash'
import Utils from '@/utils/utils'

export default {
  name: "OrderRecoveryDataTable",
  components: {
  },
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
  },
  created() {
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {}
      }
      return '/orders/recovery?' + $.param(params)
    },
    linkTarget() {
      if(this.openNewTab)
        return '_blank'

      return '_self'
    }
  },
  data() {
    return {
      columnList: [
        { title: "Id", data: "id" },
        { title: "Name", data: "name" },
        { title: "Contact", data: "contact.name" },
        { title: "User", data: "user.name" },
        { title: "Created", data: "createdAt", dateFilter: true, type: 'datetime' },
      ]
    }
  },
  mounted() {
  },
  methods: {
    reload() {
      this.$refs.dataTable.reload()
    },
    recoverOrder(orderRecoveryId) {
      this.$router.push({
        name: 'OrderNew',
        params: {
          recoverOrder: true,
          orderRecoveryId: orderRecoveryId
        }
      })
    }
  }
};
</script>
